import { PaymentMethod } from '@api/GoodocAPI';
import { useTreatmentInformationContext } from '@context/TreatmentInformation';
import { useFocusable } from '@noriginmedia/norigin-spatial-navigation';
import {
  FIRST_EXISTING_PAYMENT,
  NEW_PAYMENT
} from '@pages/Payment/PaymentSelection/focuskey';
import { PATIENT, PAYMENT, TargetPaymentTypes } from '@router/path';
import constate from 'constate';
import { useCallback } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { usePaymentMethodsContext } from '../PaymentMethods';
import { TargetPayment } from '@router/path';

const usePaymentSelection = () => {
  const navigate = useNavigate();
  const { type } = useParams<{type: TargetPaymentTypes}>();

  const { paymentMethods } = usePaymentMethodsContext();
  const { setSelectedCreditCard } = useTreatmentInformationContext();

  const goNextStep = (creditCard: Partial<PaymentMethod>) => {
    setSelectedCreditCard(creditCard);
    if (type === TargetPayment.delivery) {
      navigate(-1);
    } else {
      navigate(PATIENT.AGREEMENT);
    }
  };

  const goBack = () => {
    navigate(-1);
  };

  const goPaymentRegistration = () => {
    navigate(PAYMENT.REGISTRATION);
  };

  const { setFocus } = useFocusable();

  const setButtonFocus = useCallback(() => {
    if (paymentMethods.length > 0) {
      setFocus(FIRST_EXISTING_PAYMENT);
    } else {
      setFocus(NEW_PAYMENT);
    }
  }, [paymentMethods, setFocus]);

  return {
    paymentMethods,
    setButtonFocus,
    goNextStep,
    goBack,
    goPaymentRegistration
  };
};

export const [PaymentSelectionProvider, usePaymentSelectionContext] =
  constate(usePaymentSelection);
